// extracted by mini-css-extract-plugin
export default {"recos":"U1-z","productCardOverride":"V1-z","rowHasBadge":"W1-z"};